module.exports = __webpack_public_path__ + "static/media/aykut.945753e9.jpg";